import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32aeb774"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-add-files-wrapper" }
const _hoisted_2 = { class: "d-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_desktop_all_files = _resolveComponent("drive-desktop-all-files")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_drive_desktop_all_files, {
        selector: "",
        "hide-footer": "",
        "temporary-files": _ctx.temporaryFiles,
        onAddSelectedFiles: _ctx.fileUpdate,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, null, 8, ["temporary-files", "onAddSelectedFiles"])
    ])
  ]))
}